"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4470],{

/***/ 7354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
}), 'Cloud'));

/***/ }),

/***/ 84113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
}), 'LocationCity'));

/***/ }),

/***/ 72304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
}), 'Security'));

/***/ }),

/***/ 94470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ RedeSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41120);
/* harmony import */ var components_Functions_Loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24552);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84113);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7354);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72304);
/* harmony import */ var _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57180);
/* harmony import */ var lang_lang_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34426);


// nodejs library that concatenates classes




var GridContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 4041).then(__webpack_require__.bind(__webpack_require__, 64041));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64041)
            ];
        }
    },
    ssr: true
});
var GridItem = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 6680).then(__webpack_require__.bind(__webpack_require__, 96680));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96680)
            ];
        }
    },
    ssr: true
});
var Map = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2909), __webpack_require__.e(30)]).then(__webpack_require__.bind(__webpack_require__, 30030));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30030)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
});
var InfoArea = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 6831).then(__webpack_require__.bind(__webpack_require__, 5323));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5323)
            ];
        }
    },
    ssr: true
});
// import GridContainer from "/components/Grid/GridContainer.js";
// import GridItem from "/components/Grid/GridItem.js";
// import Map from "/components/Maps/Map.js";
// import InfoArea from "/components/InfoArea/InfoArea.js";


var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);

function RedeSection(props) {
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.section,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(classes.title),
                children: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_7__/* .trans */ .d)("index::rede_section.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(classes.title),
                children: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_7__/* .trans */ .d)("index::rede_section.subTitle")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridItem, {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Map, {
                        mapData: props.map,
                        height: "500px"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(GridContainer, {
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridItem, {
                        xs: 12,
                        sm: 10,
                        md: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InfoArea, {
                            iconColor: "success",
                            icon: _material_ui_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                            title: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_7__/* .trans */ .d)("index::rede_section.help.datacenter.title"),
                            description: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_7__/* .trans */ .d)("index::rede_section.help.datacenter.description")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridItem, {
                        xs: 12,
                        sm: 10,
                        md: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InfoArea, {
                            iconColor: "info",
                            icon: _material_ui_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                            title: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_7__/* .trans */ .d)("index::rede_section.help.pop.title"),
                            description: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_7__/* .trans */ .d)("index::rede_section.help.pop.description")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridItem, {
                        xs: 12,
                        sm: 10,
                        md: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InfoArea, {
                            iconColor: "danger",
                            icon: _material_ui_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
                            title: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_7__/* .trans */ .d)("index::rede_section.help.msr.title"),
                            description: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_7__/* .trans */ .d)("index::rede_section.help.msr.description")
                        })
                    })
                ]
            })
        ]
    });
}


/***/ })

}]);